import { create } from 'zustand';

import type { Project } from '@shaojiang/types/profile';

interface ProfileState {
  currentProject: Project | null;
  setCurrentProject: (project: Project | null) => void;
}

export const useProfileStore = create<ProfileState>()((set) => ({
  currentProject: null,
  setCurrentProject: (currentProject) => set({ currentProject }),
}));
